import { COLORS } from 'helpers/globals'

const button = {
  color: 'white',
  fontSize: '2rem',
  fontWeight: '400',
  padding: '.75rem 1.5rem',
  background: COLORS.primary,
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  '& > p': {
    marginBottom: 0,
    fontSize: '1.6rem'
  }
}

const buttonRight = {
  ...button,
  borderRight: `2px solid ${COLORS.secondary}`
}

const bottomBar = {
  flex: 1,
  zIndex: 2
}

const buttonWrapper = {
  display: 'flex',
  height: '6rem'
}

export default {
  bottomBar,
  buttonWrapper,
  addCameraButton: {
    ...buttonRight,
    background: '#009e25',
    fontWeight: '500',
    flexDirection: 'row'
  },
  addIcon: {
    marginRight: '1rem'
  },
  addFloorplanButton: {
    ...buttonRight,
    flexDirection: 'row'
  },
  moreButtonSelected: {
    ...button,
    flex: 0,
    fontSize: '3rem',
    padding: '0 1rem',
    background: '#5CA5E4'
  },
  moreButton: {
    ...button,
    flex: 0,
    fontSize: '3rem',
    padding: '0 1rem'
  },
  moreIcon: {
    margin: '0 1rem'
  },
  addList: {
    position: 'absolute',
    right: 0,
    bottom: '6rem',
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    color: COLORS.primary,
    fontWeight: '400',
    textAlign: 'left',
    border: `1px solid ${COLORS.quaternary}`,
    '& > div': {
      padding: '.75rem',
      borderBottom: `1px solid ${COLORS.quaternary}`,
      display: 'flex',
      alignItems: 'center',
      transition: 'box-shadow 200ms linear',
      '&:nth-child(even)': {
        background: COLORS.tertiary
      },
      '&:last-of-type': {
        borderBottom: 0
      },
      '&.highlight': {
        boxShadow: `0px 0px 4px 1px ${COLORS.primary}`
      }
    }
  },
  icon: {
    marginRight: '.75rem',
    width: '2rem !important',
    fontSize: '1.8rem'
  },
  highlightArrow: {
    position: 'absolute',
    color: COLORS.danger,
    fontSize: '4rem',
    left: '-4rem',
    bottom: 0
  }
}

export const cameraButtonsStyle = {
  bottomBar,
  buttonWrapper,
  button,
  buttonRight,
  simulatedViewButtonBoth: {
    ...buttonRight,
    borderLeft: `2px solid ${COLORS.secondary}`,
    fontSize: '2.3rem',
    position: 'relative'
  },
  simulatedViewButtonSelect: {
    ...buttonRight,
    background: '#009e25',
    borderLeft: `2px solid ${COLORS.secondary}`,
    fontSize: '2.3rem'
  },
  selectModelButton: {
    ...button,
    background: '#009e25',
    fontSize: '1.8rem',
    textAlign: 'center'
  },
  editModelButton: {
    ...button,
    fontSize: '1.8rem',
    textAlign: 'center'
  },
  editConfigButton: buttonRight,
  addList: {
    position: 'absolute',
    right: 0,
    bottom: '6rem',
    display: 'flex',
    flexDirection: 'column',
    background: 'white',
    color: COLORS.primary,
    fontWeight: '400',
    textAlign: 'left',
    border: `1px solid ${COLORS.quaternary}`,
    '& > div': {
      padding: '.75rem',
      borderBottom: `1px solid ${COLORS.quaternary}`,
      display: 'flex',
      alignItems: 'center',
      '&:nth-child(even)': {
        background: COLORS.tertiary
      },
      '&:last-of-type': {
        borderBottom: 0
      }
    }
  },
  moreButtonSelected: {
    ...button,
    flex: 0,
    fontSize: '3rem',
    padding: '0 2rem',
    background: '#5CA5E4'
  },
  moreButton: {
    ...button,
    flex: 0,
    fontSize: '3rem',
    padding: '0 2rem'
  },
  icon: {
    marginRight: '.75rem',
    width: '2rem !important',
    fontSize: '1.8rem'
  },
  setIcon: {
    position: 'absolute',
    top: '.25rem',
    right: '.75rem',
    fontSize: '1.75rem'
  }
}

export const otherButtonsStyle = {
  bottomBar,
  buttonWrapper,
  button: {
    ...button,
    fontWeight: '500',
    flexDirection: 'row'
  },
  buttonRight: {
    ...buttonRight,
    fontWeight: '500',
    flexDirection: 'row'
  },
  icon: {
    marginRight: '1rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/BottomBar/Buttons/style.js